import $api from "@/frontend/shared/api/axios";

export async function deleteExpertSectionNote({
  companyId,
  noteId,
  organizationId
}: {
  companyId: number;
  noteId: number;
  organizationId: number;
}) {
  return await $api.delete(`/experts/organizations/${organizationId}/portfolio-companies/${companyId}/notes/${noteId}`);
}
